import { apiRoute } from "services";
import API from "services/lib/api";
import ConnectButton from "../common/ConnectButton/ConnectButton";
import { inboxAppsActionTypes } from "../enum";

const FacebookIntegration = ({
    handleNewConnection,
    user,
    actionType,
    appUserId,
    handleSuccess,
    handleError,
}) => {
    const { workspace } = user;

    const connectFacebook = async () => {
        try {
            handleNewConnection("Facebook", inboxAppsActionTypes?.CONNECT);
            const url = apiRoute?.authorizeFacebook;

            const res = await API.post(
                url,
                {},
                {
                    headers: {
                        workspaceid: workspace?.workspaceId,
                    },
                }
            );
            if (res.status === 201) {
                const { authUrl } = res.data.data;
                window.location.href = authUrl;
            }
        } catch (err) {
            handleError(err);
        }
    };

    const disconnectFacebook = async () => {
        try {
            handleNewConnection("Facebook", inboxAppsActionTypes?.DISCONNECT);
            const url = apiRoute?.disconnectInboxApp(appUserId);
            const res = await API.delete(url);
            if (res.status === 200) {
                handleSuccess();
            }
        } catch (err) {
            handleError(err);
        }
    };

    return (
        <>
            <ConnectButton
                onClick={
                    actionType === inboxAppsActionTypes.CONNECT
                        ? connectFacebook
                        : disconnectFacebook
                }
                buttonText={
                    actionType === inboxAppsActionTypes.CONNECT
                        ? "Connect"
                        : "Disconnect"
                }
            />
        </>
    );
};

export default FacebookIntegration;